var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 660,
    viewBox: "0 0 1512 660",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_352_265",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1512,
    height: 660
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M408.651 0C387.918 0 371.11 12.556 371.11 28.0446C371.11 66.6723 339.796 97.9863 301.168 97.9863H37.5414C16.8078 97.9863 0 110.542 0 126.031V631.955C0 647.444 16.8078 660 37.5414 660H864.953C885.687 660 902.494 647.444 902.494 631.955C902.494 593.328 933.808 562.014 972.436 562.014H1495.04C1515.77 562.014 1511.67 549.458 1511.67 533.969V28.0446C1511.67 12.556 1515.77 0 1495.04 0H408.651Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M371.61 28.0446C371.61 20.4938 375.706 13.619 382.405 8.61464C389.104 3.61018 398.382 0.5 408.651 0.5H1495.04C1500.18 0.5 1503.72 1.28026 1506.14 2.64C1508.54 3.98756 1509.9 5.92814 1510.65 8.36146C1511.41 10.8179 1511.55 13.7712 1511.49 17.1193C1511.46 18.4631 1511.41 19.8821 1511.35 21.3525C1511.26 23.4981 1511.17 25.7532 1511.17 28.0446V533.969C1511.17 536.26 1511.26 538.516 1511.35 540.661C1511.41 542.132 1511.46 543.551 1511.49 544.894C1511.55 548.243 1511.41 551.196 1510.65 553.652C1509.9 556.086 1508.54 558.026 1506.14 559.374C1503.72 560.733 1500.18 561.514 1495.04 561.514H972.436C933.532 561.514 901.994 593.052 901.994 631.955C901.994 639.506 897.898 646.381 891.2 651.385C884.5 656.39 875.222 659.5 864.953 659.5H37.5414C27.2719 659.5 17.994 656.39 11.2948 651.385C4.59581 646.381 0.5 639.506 0.5 631.955V126.031C0.5 118.48 4.59581 111.605 11.2948 106.601C17.994 101.596 27.2719 98.4863 37.5414 98.4863H301.168C340.072 98.4863 371.61 66.9484 371.61 28.0446Z",
    stroke: "#741374",
    strokeOpacity: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_352_265)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_352_265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-17.4258 493.192C19.9488 362.823 246.318 115.1 663.588 336.748C1185.18 613.808 1144.73 419.866 1302.98 428.887C1429.58 436.103 1478.26 531.12 1486.78 577.726",
    stroke: "#741374",
    strokeOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_352_265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1552 28.0274C1552 94.9532 1508.79 155.618 1438.77 199.576C1368.76 243.53 1272.01 270.733 1165.12 270.733C1058.23 270.733 961.48 243.53 891.47 199.576C821.453 155.618 778.244 94.9532 778.244 28.0274C778.244 -38.8985 821.453 -99.563 891.47 -143.521C961.48 -187.476 1058.23 -214.678 1165.12 -214.678C1272.01 -214.678 1368.76 -187.476 1438.77 -143.521C1508.79 -99.563 1552 -38.8985 1552 28.0274Z",
    stroke: "#741374",
    strokeOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_352_265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M914.67 716.507C914.67 766.004 871.561 810.972 801.498 843.594C731.477 876.198 634.707 896.377 527.792 896.377C420.876 896.377 324.107 876.198 254.085 843.594C184.023 810.972 140.914 766.004 140.914 716.507C140.914 667.009 184.023 622.042 254.085 589.419C324.107 556.816 420.876 536.637 527.792 536.637C634.707 536.637 731.477 556.816 801.498 589.419C871.561 622.042 914.67 667.009 914.67 716.507Z",
    stroke: "#741374",
    strokeOpacity: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_352_265",
    x: -24.7063,
    y: 240.723,
    width: 1518.77,
    height: 343.893,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4,
    result: "effect1_foregroundBlur_352_265"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_352_265",
    x: 770.944,
    y: -221.978,
    width: 788.356,
    height: 500.011,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4,
    result: "effect1_foregroundBlur_352_265"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_352_265",
    x: 133.614,
    y: 529.337,
    width: 788.356,
    height: 374.34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4,
    result: "effect1_foregroundBlur_352_265"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMask);
export default __webpack_public_path__ + "static/media/Mask .d91489c85985a24d334dfb2bbe9ce28f.svg";
export { ForwardRef as ReactComponent };